import { compose } from 'redux';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';

import Subheading from '../../../components/common/Heading/subhead';
import { isLoggedIn } from '../../../components/common/Helpers';

const mapStateToProps = (state, ownProps) => {
  const isCradleFlow = state?.contactInfo?.isCradleSuccess;

  const totalDueTodayAmount = isLoggedIn()
    ? state?.checkout?.orderDetails?.totalDueToday
    : state?.cartDetails?.cartDetailsJson?.orderDetailsView?.dueTodayAmount;

  const fwaSecurityDepositAmount = state?.cartDetails?.cartDetailsJson?.orderDetailsView?.fwaSecurityDepositAmount || 0;

  return { cradleSubHeading: ownProps.cradlesubheading, isCradleFlow, totalDueTodayAmount, fwaSecurityDepositAmount };
};
function mapDispatchToProps() {}

const withConnect = connect(mapStateToProps, mapDispatchToProps);

export default withRouter(compose(withConnect)(Subheading));
